<template>
  <el-dialog
    append-to-body
    width="800px"
    title="详情"
    :visible.sync="visible"
    :before-close="resetDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div
      style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px"
    >
      <div>{{ viewInfo.nickname }}</div>
      <div>{{ viewInfo.account }}</div>
      <div>获赠积分:{{ viewInfo.total_integral }}</div>
      <div>消耗积分:{{ viewInfo.expend_integral }}</div>
      <div>剩余积分:{{ viewInfo.integral }}</div>
    </div>
    <el-radio-group
      size="mini"
      v-model="table.params.type"
      @change="onSearch"
      style="margin-bottom: 10px"
    >
      <el-radio-button :label="0">全部</el-radio-button>
      <el-radio-button :label="1">获赠</el-radio-button>
      <el-radio-button :label="2">消耗</el-radio-button>
    </el-radio-group>
    <el-table
      :data="table.data"
      ref="tableDom"
      :max-height="400"
      border
      style="width: 100%; margin-bottom: 10px"
      v-loading="table.loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0)"
      :header-cell-style="{ background: '#f5f5f5' }"
    >
      <el-table-column type="index" align="center" width="50" label="序号">
      </el-table-column>
      <el-table-column label="积分类型" prop="nickname" align="center">
        <template #default="{ row }">
          {{ { 1: "获赠", 2: "消耗" }[row.type] }}
        </template>
      </el-table-column>
      <el-table-column label="积分" prop="value" align="center">
      </el-table-column>
      <el-table-column
        label="明细"
        prop="get_type"
        align="center"
        min-width="120"
      >
        <template #default="{ row }">
          <div>
            {{
              { 1: "登录", 2: "选择师傅", 3: "评价", 4: "查看手机号" }[
                row.get_type
              ]
            }}
          </div>
          <div style="font-size: 12px">{{ row.object_name }} {{ row.phone }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time"
        align="center"
        min-width="120"
      >
      </el-table-column>
    </el-table>
    <div class="pagination__wrap">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="table.params.page"
        :page-size="table.params.count"
        :total="table.total"
        :page-sizes="[10, 20, 50, 100, 150]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import { mixinTable } from "@/mixins/table.js";
export default {
  mixins: [mixinTable],
  data() {
    return {
      visible: false,
      loading: false,
      labelStyle: { width: "100px", textAlign: "center" },
      contentStyle: { width: "300px" },
      info: {},
      table: {
        loading: false,
        params: {
          type: 0,
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
      viewInfo: {},
    };
  },
  methods: {
    getDetail(row) {
      this.info = row;
      this.getTable();
    },
    getTable() {
      let _params = { ...this.table.params, user_id: this.info.id };
      this.table.loading = true;
      this.$http
        .get("/admin/flex_trade/integralInfo", { params: _params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
            this.viewInfo = res.data;
            this.$nextTick(() => {
              this.$refs.tableDom.doLayout();
            });
          }
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    resetDialog(done) {
      this.table = {
        loading: false,
        params: { type: 0, page: 1, count: 10 },
        data: [],
        total: 0,
      };
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.resetDialog();
    },
  },
};
</script>
